import I18n from 'I18n';
import styled from 'styled-components';
import { NEUTRAL_300, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import { ChatWidgetLocaleContextConsumer } from '../ChatWidgetLocaleContext';
import ConsentPrompt from '../ConsentPrompt';
import { PROMPT_RECOMMENDATIONS, QUICK_REPLIES } from '../constants/consentPromptUsages';
import { jsx as _jsx } from "react/jsx-runtime";
const ConsentPromptWrapper = styled.div.withConfig({
  displayName: "ConsentPromptsOutsideChat__ConsentPromptWrapper",
  componentId: "sc-1sxmuwi-0"
})(["background:", ";color:", ";width:", ";"], NEUTRAL_300, OBSIDIAN, ({
  usageType
}) => usageType === PROMPT_RECOMMENDATIONS ? '384px' : '100%');
const ConsentPromptsOutsideChat = ({
  renderCookieConsentPrompt = false,
  consentToCookies,
  showingGdprProcess = false,
  consentToProcessMessage,
  showGdprConsentToProcessButton = false,
  consentToProcess,
  closeConsentToProcess,
  isPortal53 = false,
  usageType = QUICK_REPLIES
}) => {
  if (!renderCookieConsentPrompt && !showingGdprProcess) {
    return null;
  }
  if (renderCookieConsentPrompt) {
    return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
      children: locale => /*#__PURE__*/_jsx(ConsentPromptWrapper, {
        usageType: usageType,
        children: /*#__PURE__*/_jsx(ConsentPrompt, {
          showButton: true,
          message: I18n.text('conversations-visitor-experience-components.gdpr.consentToCookies.pageLoadCookieConsent', {
            locale
          }),
          onClick: consentToCookies,
          isPortal53: isPortal53,
          isOutsideChat: true
        })
      })
    });
  }
  if (showingGdprProcess) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      usageType: usageType,
      children: /*#__PURE__*/_jsx(ConsentPrompt, {
        showButton: showGdprConsentToProcessButton,
        message: consentToProcessMessage,
        onClick: consentToProcess,
        onClose: closeConsentToProcess,
        isPortal53: isPortal53,
        isOutsideChat: true
      })
    });
  }
  return null;
};
ConsentPromptsOutsideChat.displayName = 'ConsentPromptsOutsideChat';
export default ConsentPromptsOutsideChat;